<template>
  <main>
    <Date />
    <Sponsor />
  </main>
</template>

<script>
import { getBaseURL, getBaseMetaCurrentYear } from '@/environments'

const Date = () => import('@/components/Date/Main')
const Sponsor = () => import('@/components/Sponsor/Main')

export default {
  components: {
    Date,
    Sponsor
  },

  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: getBaseURL() },
      { name: 'og:title', content: `Adman Awards & Symposium ${getBaseMetaCurrentYear}` },
      { name: 'og:description', content: 'Be the First Winner of the Most Honorable Award' },
      { name: 'og:image', content: `${getBaseURL()}/img/og_adman.jpg` },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  }
}
</script>
